export default __webpack_public_path__ + "static/media/landscape_prep.46367aa3.jpg";